// // components/Card.jsx
import React from "react";

const Card = ({ title, value = 0, icon, progress = 0, size }) => {
  // Ensure numeric safety
  const safeValue =
    typeof value === "number" && !isNaN(value) ? value : 0;

  const safeProgress =
    typeof progress === "number" && !isNaN(progress) ? progress : 0;

  // Determine progress bar color
  let progressColor = "bg-orange-500";
  if (safeProgress < 30) {
    progressColor = "bg-orange-300";
  } else if (safeProgress > 80) {
    progressColor = "bg-orange-700";
  }

  // Size-based styles
  const containerClass =
    size === "small"
      ? "bg-white p-2 rounded-lg shadow space-y-2"
      : "bg-white p-4 rounded-xl shadow space-y-3";

  const titleClass =
    size === "small"
      ? "text-xs font-medium text-gray-500"
      : "text-sm font-medium text-gray-500";

  const iconClass = size === "small" ? "text-xl" : "text-2xl";

  const valueClass =
    size === "small"
      ? "text-xl font-semibold text-gray-800"
      : "text-3xl font-semibold text-gray-800";

  const progressBarHeight = size === "small" ? "h-1" : "h-2";

  const progressTextClass =
    size === "small"
      ? "text-right text-[10px] text-gray-500"
      : "text-right text-xs text-gray-500";

  return (
    <div className={containerClass}>
      {/* Title + Icon */}
      <div className="flex justify-between items-center">
        <div className={titleClass}>{title}</div>
        <div className={iconClass}>{icon}</div>
      </div>

      {/* Main value */}
      <div className={valueClass}>{safeValue}</div>

      {/* Progress bar */}
      <div
        className={`w-full bg-gray-200 ${progressBarHeight} rounded-full overflow-hidden`}
      >
        <div
          className={`${progressColor} h-full rounded-full transition-all duration-700`}
          style={{ width: `${safeProgress}%` }}
        />
      </div>

      {/* Progress text */}
      <div className={progressTextClass}>
        {safeProgress.toFixed(0)}%
      </div>
    </div>
  );
};

export default Card;

// import React from "react";

// const Card = ({ title, value, icon, progress, size }) => {
//   // Determine progress bar color based on progress percentage
//   let progressColor = "bg-orange-500";
//   if (progress < 30) {
//     progressColor = "bg-orange-300";
//   } else if (progress > 80) {
//     progressColor = "bg-orange-700";
//   }

//   // Define container padding and rounded size depending on size prop
//   // Smaller padding and slightly smaller rounded corners for 'small' size
//   const containerClass =
//     size === "small"
//       ? "bg-white p-2 rounded-lg shadow space-y-2"  // smaller padding & space between elements
//       : "bg-white p-4 rounded-xl shadow space-y-3"; // default styling

//   // Title text size - smaller on 'small'
//   const titleClass =
//     size === "small"
//       ? "text-xs font-medium text-gray-500"
//       : "text-sm font-medium text-gray-500";

//   // Icon size - smaller on 'small'
//   const iconClass = size === "small" ? "text-xl" : "text-2xl";

//   // Value text size - smaller on 'small'
//   const valueClass =
//     size === "small"
//       ? "text-xl font-semibold text-gray-800"
//       : "text-3xl font-semibold text-gray-800";

//   // Progress bar height - smaller on 'small'
//   const progressBarHeight = size === "small" ? "h-1" : "h-2";

//   // Bottom progress text size
//   const progressTextClass =
//     size === "small"
//       ? "text-right text-[10px] text-gray-500"
//       : "text-right text-xs text-gray-500";

//   return (
//     <div className={containerClass}>
//       {/* Title and icon row */}
//       <div className="flex justify-between items-center">
//         <div className={titleClass}>{title}</div>
//         <div className={iconClass}>{icon}</div>
//       </div>

//       {/* Main value */}
//       <div className={valueClass}>{value}</div>

//       {/* Progress bar */}
//       <div className={`w-full bg-gray-200 ${progressBarHeight} rounded-full overflow-hidden`}>
//         <div
//           className={`${progressColor} h-full rounded-full transition-all duration-700`}
//           style={{ width: `${progress}%` }}
//         />
//       </div>

//       {/* Progress text */}
//       <div className={progressTextClass}>{progress.toFixed(0)}%</div>
//     </div>
//   );
// };

// export default Card;
